import { render, staticRenderFns } from "./SelectText.vue?vue&type=template&id=58b6c7cc"
import script from "./SelectText.vue?vue&type=script&lang=js"
export * from "./SelectText.vue?vue&type=script&lang=js"
import style0 from "./SelectText.vue?vue&type=style&index=0&id=58b6c7cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports